import { NamedContext, useNamedContext } from "@toolkit/Framework/Components/NamedContext/NamedContext";
import React, { FC, PropsWithChildren, useMemo } from "react";

export interface NamedContextProviderProps {
    value: string;
}

export const NamedContextProvider: FC<PropsWithChildren<NamedContextProviderProps>> = ({ value, children }) => {
    const parentNames = useNamedContext();
    const currentNames = useMemo(() => [value, ...parentNames], [value, parentNames]);

    return <NamedContext.Provider value={currentNames}>{children}</NamedContext.Provider>;
};
